import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home.component';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProvidersComponent } from './providers/providers-list/providers.component';
import { ProviderBillByDateComponent } from './providers/provider-bill-by-date/provider-bill-by-date.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'providers',
        component: ProvidersComponent,
      },
      {
        path: 'providers-range-date',
        component: ProviderBillByDateComponent,
      },
      {
        path: '',
        loadChildren: () => import('./providers/providers.module').then(m => m.ProvidersModule),
      },
      {
        path: 'crm',
        loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
      },
      {
        path: '',
        loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule),
      },
      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule { }
